<template>
	<section id="external-specs" class="external-specs">
		<hr>
		<div class="container">
			<div class="row">
				<div class="col-md-6">
					<div class="external-specs-content">
						<h2 class="external-specs-content-heading text-uppercase">
							{{ landing_page_sections.title | stripTags }}
						</h2>
						<div class="external-specs-content-list" v-html="landing_page_sections.body" />
					</div>
				</div>
				<div class="col-md-6">
					<div class="external-specs-image">
						<img :src="landing_page_sections.logo_url">
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { mapState } from "vuex";

export default {
	name: "ExternalSpecs",
	props: {
		landingPageIndex: {
			type: [String, Number],
			required: true
		}
	},
	computed: mapState({
		landing_page_sections(state) {
			const landingPageSections = state.StarterPc.pageData.landing_page_sections;
			return landingPageSections && landingPageSections[this.landingPageIndex] || {};
		}
	})
};
</script>

<style lang="scss" scoped>
@import "~@s/_asset-mixers.scss";

.external-specs {

    hr {
        border-top: 1px solid #dadde0;
    }

    .row {
        @media screen and (max-width: 768px) {
            display: flex;
            flex-direction: column-reverse;
        }

        @media screen and (min-width: 991px) {
            display: flex;
            align-items: center;
        }
    }

    .container {
        padding-top: 40px;
        padding-bottom: 40px;
    }

    &-content {
        max-width: 530px;
        margin-left: auto;

        @media (min-width: 580px) and (max-width: 991px) {
            margin: 0 auto;
        }

        &-heading {
            color: #444259;
            font-size: 36px;
            line-height: 43px;
            text-align: right;
            margin-bottom: 15px;

            @media (min-width: 580px) and (max-width: 991px) {
                width: 100%;
                text-align: center;
            }

            @media (max-width: 580px) {
                line-height: 38px;
                text-align: left;
                margin: -5px 0 25px;
            }
        }

        &-list {
            text-align: right;

            @media (min-width: 580px) and (max-width: 991px) {
                text-align: center;
            }

            @media (max-width: 580px) {
                text-align: left;
            }
        }

        &-item {
            margin-bottom: 20px;

            &-name,
            &-description {
                font-size: 14px;
            }

            &-name {
                color: #47445B;
                font-weight: bold;
                margin: 0;    width: 100%;
            }

            &-description {
                color: #5F707F;
            }

        }
    }

    &-image {
        text-align: right;
        padding-right: 30px;

        @media (min-width: 991px) and (max-width: 1025px) {
            padding-left: 30px !important;
        }

        @media (min-width: 580px) and (max-width: 991px) {
            margin-top: -30px;
        }

        @media (max-width: 1025px) {
            text-align: center;
            padding: 0;
        }

        @media (max-width: 580px) {
            width: 100%;

            img {
                width: 100%;
            }
        }
    }
}
</style>
